export class Provenance {

    prv_id: string;
    prv_libelle: string;

    constructor(data?: any) {
        if (!data) {
            data = [];
        }

        this.prv_id         = data['prv_id'] ? data['prv_id'] : null;
        this.prv_libelle    = data['prv_libelle'] ? data['prv_libelle'] : null;
    }

}
